<button
  class="btn btn-white btn-sm text-secondary pr-2"
  (click)="onToggle(); (false)"
>
  <i class="fe fe-sliders"></i> {{ 'list.filters.more-btn' | translate }}
</button>
